import { render } from "./UploadPhotoModal.vue?vue&type=template&id=1da3fb9b&scoped=true"
import script from "./UploadPhotoModal.vue?vue&type=script&lang=js"
export * from "./UploadPhotoModal.vue?vue&type=script&lang=js"

import "./UploadPhotoModal.vue?vue&type=style&index=0&id=1da3fb9b&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1da3fb9b"]])

export default __exports__